"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Star = function Star(props) {
  var starProps = Object.assign({}, props);
  var nameMap = {
    isDisabled: 'is-disabled',
    isActive: 'is-active',
    isActiveHalf: 'is-active-half',
    willBeActive: 'will-be-active'
  };
  var className = Object.keys(nameMap).filter(function (prop) {
    return delete starProps[prop], props[prop];
  }).map(function (prop) {
    return nameMap[prop];
  }).join(' ');
  return _react["default"].createElement("div", _extends({
    className: "react-rater-star ".concat(className)
  }, starProps), "\u2605");
};

Star.defaultProps = {
  willBeActive: false,
  isActive: false,
  isActiveHalf: false,
  isDisabled: false
};
Star.propTypes = {
  isActive: _propTypes["default"].bool,
  isActiveHalf: _propTypes["default"].bool,
  willBeActive: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool
};
var _default = Star;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rater/lib/star.js
// module id = 519
// module chunks = 0